import { AgoraLinkTypeE, AgoraPlanNameE, SupportedCountriesE } from '@/types/cyclone/models';

export const isInternationalAgoraUp = (vendor?: { plan_name?: string; country?: string }): boolean =>
  vendor?.plan_name === AgoraPlanNameE.AGORA_UP &&
  !!vendor.country &&
  vendor.country !== SupportedCountriesE.ARGENTINA &&
  vendor.country !== SupportedCountriesE.URUGUAY;

export const isUpHiddenCatalogPath = (path?: string): boolean =>
  !!path && /^\/(eventos|cursos-online|curso-online|tarjetas-de-regalo)(\/|\?|$)/.test(path);

export const isUpHiddenLinkType = (type?: AgoraLinkTypeE): boolean =>
  type === AgoraLinkTypeE.EVENT || type === AgoraLinkTypeE.ONLINE_COURSE || type === AgoraLinkTypeE.GIFT_CARD;
